module.exports = __webpack_public_path__ + "img/Refresh Icon - charcoal.395986d7.svg";